import { FormattedMessage, useIntl } from 'react-intl'

import { ButtonGroup, Card, CardBody, Heading, Text } from 'Components/_theme'

import type { OrderSummaryQuantityConfirmationModalProps } from '../OrderSummary.types'

export const OrderSummaryQuantityConfirmationModal = (
  props: OrderSummaryQuantityConfirmationModalProps,
) => {
  const { items, onCancel, onConfirm } = props

  const intl = useIntl()

  const [singleItem] = items

  return (
    <Card className="text-center">
      <CardBody>
        <Heading className="mt-9 mb-2" size={4}>
          <FormattedMessage id="NewOrderSummary_quantity_confirmation_heading" />
        </Heading>

        <Text className="pb-6">
          {items.length === 1 && singleItem ? (
            <FormattedMessage
              id="NewOrderSummary_quantity_confirmation_text"
              values={{ quantity: singleItem.quantity }}
            />
          ) : (
            <>
              <FormattedMessage id="NewOrderSummary_quantity_confirmation_text_multiple" />

              <ul className="text-start mt-2">
                {items.map(item => (
                  <li key={item.name}>
                    {item.name}: {item.quantity}
                  </li>
                ))}
              </ul>
            </>
          )}
        </Text>

        <ButtonGroup
          leftButton={{
            onClick: onCancel,
            text: intl.formatMessage({
              id: 'NewOrderSummary_quantity_confirmation_cancel',
            }),
          }}
          rightButton={{
            onClick: onConfirm,
            text: intl.formatMessage({
              id: 'NewOrderSummary_quantity_confirmation_confirm',
            }),
          }}
        />
      </CardBody>
    </Card>
  )
}
